<template>
  <base-dialog width="485px" class="add-new-participant-dialog" :visible.sync="visible" show-close>
    <template v-slot:header>
      添加参与人
    </template>
    <el-form v-loading="loading">
      <el-form-item label="设置新参与人员/角色">
        <user-scope-selector
          multiple
          :users="projectUsers"
          v-model="userIdList"
          :showDepartmentTab="false"
          :showUserTab="false"
          tip="选择参与人员/角色"
          :additional-tabs="additionalTabs"
          :root-department="rootDepartment"
          v-bind="$attrs"
        ></user-scope-selector>
      </el-form-item>
    </el-form>
    <template v-slot:footer>
      <base-button @click="visible = false">取消</base-button>
      <base-button type="primary" @click="submit">确认</base-button>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import UserScopeSelector from "@/components/UIComponents/UserScopeSelector"
import { getProjectUsers } from "@/api/project/project"
import { getDepartmentTree } from "@/api/userCenter/company"

export default {
  name: "AddNewParticipantDialog",
  components: { BaseButton, BaseDialog, UserScopeSelector },
  props: {
    roles: {
      required: true,
      type: Array
    },
    projectId: String
  },
  data() {
    return {
      visible: false,
      userIdList: [],
      loading: false,
      projectUsers: [],
      rootDepartment: {}
    }
  },
  computed: {
    curUser() {
      return this.$store.getters.userInfo
    },
    additionalTabs() {
      return [
        {
          label: "项目人员",
          value: "user",
          options: this.projectUsers.map(({ id, name }) => ({ id, name }))
        },
        {
          label: "项目角色",
          value: "peojectRole",
          options: [{ id: "100", name: "全部角色" }].concat(
            this.roles.map(({ id, name }) => ({ id, name }))
          )
        }
      ]
    }
  },
  methods: {
    open() {
      this.userIdList = []
      this.visible = true
      this.init()
    },
    init() {
      this.loading = true
      // 获取项目人员 项目角色
      Promise.all([
        getDepartmentTree({ companyId: this.curUser.companyId }).then(departmentTree => {
          this.rootDepartment = departmentTree[0]
        }),
        getProjectUsers(this.projectId).then(projectRes => (this.projectUsers = projectRes))
      ]).finally(() => (this.loading = false))
    },
    submit() {
      let userId = this.userIdList.filter(item => item.type === "user").map(res => res.value)
      let roleId = this.userIdList.filter(item => item.type === "peojectRole").map(res => res.value)
      let isAllRole =
        this.userIdList.filter(item => item.value === "100" && item.type === "peojectRole")
          .length >= 1
      if (isAllRole) {
        // 全部角色
        roleId = this.roles.map(u => u.id)
      }
      this.$emit("select", userId, roleId)
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-participant-dialog {
  .el-form {
    margin-top: 18px;
    ::v-deep {
      .el-form-item__content {
        display: flex;
        .el-select {
          flex: 1;
        }
        > span {
          flex: 1;
        }
      }
    }
  }
}
</style>
